const footer = {
  footer: {
    imageTitle: 'Enphase Energy の Web サイトを見る',
    privacy: 'プライバシー',
    terms: '条件',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc.無断転載を禁じます。',
    language: '言語',
    production_ct: {
      verify_ct: "CT の検証",
      checlist_nodata: "このチェックを行うためのメーターデータが不十分",
      production_meter_verification: "発電量CT の検証",
      serial_no: "シリアル番号",
      polarity_check: "極性チェック",
      polarity_check_failed: "極性チェックに失敗",
      ct_missing_branch_check: "CT の分岐回路が欠落していないかチェックする",
      polarity_check_passed: "極性チェック合格",
      ct_no_missing_branch_circuit: "CT には分岐回路の欠落はありません",
      incorrect_direction_or_phase_message: "発電量CT の向きまたは相が正しくない可能性があります",
      hide_details: "詳細を非表示",
      check_try_again: "以下をチェックし、もう一度試してください",
      pv_on_for_5_min: "PV 回路がオンになっており、少なくとも 5 分間オンになっていることを確認します",
      l1_wires_production_ct_message: "L1 ワイヤのみが発電量 CTを通過し、電力の流れが PV からブレーカーへ CT の矢印の方向であることを確認します",
      blue_white_wires_position_message: "青と白のワイヤーがゲートウェイ端子台の正しい位置に接続されていることを確認します",
      wires_include_pv_generation_not_load_storage: "発電量 CT を通る電線にはPV発電のみを含めます (負荷や蓄電池は含めない)",
      l1_a_correct_phase_message: "正しい相、つまり L1(a) が、発電量 CT を通過していることを確認します",
      l1_phase_consistency_check_message: "デジタルメーターで L1 の相整合性をチェックし、PV 回路の L1 とゲートウェイの L1 が同相であることを確認します",
      missing_branch_warning: "発電量CTには分岐回路が欠けている可能性があります",
      test_only_valid_for_sunshine_hours: "このテストは日照時間のみ有効です",
      reading_lower_than_expected: "発電量の読み取り値は予想を下回った。以下をチェックし、タップしてもう一度試してください",
      wires_include_all_pv_generation: "発電量 CT を通る配線に、すべての PV 発電回路が含まれていることを確認します",
      branch_circuit_reverse_check: "どの分岐回路も逆向きでCTを通過していないことを確認してください",
      storage_load_circuits_through_production_ct: "発電量CT を経由する蓄電池回路や負荷回路がないことを確認します",
      show_details: "詳細を表示",
      verify_ct_not_supported_for_device: "このデバイスではCT はサポートされていません",
      verify_ct_timeStamp: "次をチェック",
      verify_ct_systemID: "システム ID",
      prodct_reversepolarity_text: "発電量CT の向きまたは相が正しくない可能性があります",
      prodct_reverse_polarity_btn: "逆極性",
      verify_ct_timeout: "リクエストがタイムアウトしました。もう一度お試しください。"
    }
  }
};

export default footer;
